import React, { useEffect } from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { getCurrentProduct } from 'lib/CheckProduct'

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_KEY,
  enabledReleaseStages: ['staging', 'production'],
  plugins: [new BugsnagPluginReact(React)],
  releaseStage: import.meta.env.VITE_ENV,
  metadata: {
    product: {
      product: getCurrentProduct()
    }
  },
  onError: event => {
    if (
      // ignore the AudioWorkletNode warning from Nuance
      event?.originalError?.message?.includes('NUSAI_')
    ) {
      return false
    }

    // Ignore worker-load failures from extendable-media-recorder-wav-encoder
    // (used by react-media-recorder for AI Notes recording). That library
    // revokes its Worker's blob URL before the worker finishes loading and
    // never attaches an onerror handler, so a slow/failed load surfaces here
    // as an unhandled "NetworkError: Load failed" with no real stack frame
    // (just blob:<uuid>:line:col). Benign and not actionable on our side.
    const topFrame = event?.errors?.[0]?.stacktrace?.[0]

    if (
      event?.originalError?.message?.includes('Load failed') &&
      topFrame?.file?.startsWith('blob:')
    ) {
      return false
    }

    return true
  }
})

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

function BugsnagErrorHandler({ currentAccount, children }) {
  useEffect(() => {
    if (currentAccount?.currentAccount) {
      Bugsnag.setUser(
        currentAccount?.currentAccount?.id,
        currentAccount?.currentAccount?.email,
        currentAccount?.currentAccount?.fullName
      )
    }
  }, [currentAccount?.currentAccount])

  return <ErrorBoundary>{children}</ErrorBoundary>
}

export default BugsnagErrorHandler
